var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialIcons7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 42,
    viewBox: "0 0 26 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8988 24.5924L22.1 24.5921L22.2823 23.4048L23.2574 17.0528L23.5049 15.4404H21.8736H17.1783V12.7183C17.1783 12.0531 17.3436 11.5677 17.6042 11.2663C17.8319 11.0029 18.2987 10.6862 19.3596 10.6862H22.1303H23.5303V9.28618V3.87859V2.69719L22.3657 2.49852L22.1303 3.87859C22.3657 2.49852 22.3656 2.4985 22.3655 2.49848L22.3652 2.49843L22.3644 2.4983L22.3622 2.49792L22.3549 2.4967L22.3298 2.49252C22.3084 2.48897 22.2777 2.48395 22.2383 2.47767C22.1597 2.46511 22.0464 2.44748 21.9037 2.42649C21.6185 2.38453 21.2145 2.32892 20.7332 2.27338C19.7766 2.16298 18.4885 2.04971 17.2119 2.04971C14.4193 2.04971 11.956 2.90142 10.1892 4.67006C8.42096 6.4401 7.51183 8.96675 7.51183 11.9998V15.4415H3.33203H1.93203V16.8415V23.1935V24.5935H3.33203H7.51183V38.5497V39.9497H8.91183H15.7783H17.1783V38.5497V24.5932L20.8988 24.5924Z",
    stroke: "#00C5FF",
    strokeWidth: 2.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons7);
export default __webpack_public_path__ + "static/media/social-icons7.8211a86625f7f960453d701465aee07c.svg";
export { ForwardRef as ReactComponent };